<template>
  <div class="flex gap-1">
    <div class="flex-1">
      <div class="flex">
        <div class="px-1 w-[25%] text-start me-1">
          <NText variant="caption2">
            {{ t('misc.quantity') }}
          </NText>
        </div>
        <div class="flex items-center justify-between flex-1">
          <NText variant="caption2" class="align-bottom">
            {{ t('symbol.volume') }}
          </NText>
          <NText variant="caption2" class="align-bottom">
            {{ t('symbol.price') }}
          </NText>
        </div>
      </div>
    </div>

    <div class="w-1/2">
      <div class="flex">
        <div class="flex items-center justify-between flex-1">
          <NText variant="caption2" class="align-bottom">
            {{ t('symbol.price') }}
          </NText>
          <NText variant="caption2" class="align-bottom">
            {{ t('symbol.volume') }}
          </NText>
        </div>
        <div class="px-1 w-[25%] text-end mx-1">
          <NText variant="caption2">
            {{ t('misc.quantity') }}
          </NText>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>
